<template>
  <v-dialog
    v-model="loader.show"
    persistent
    width="300"
  >
    <v-card
      color="primary"
      dark
    >
      <div
        v-show="loader.status !== null"
        class="pa-3 text-center subtitle-1"
      >
        {{ loader.status }}
      </div>
      <v-card-text>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Loader',

  computed: {
    loader () {
      return this.$store.state.loader
    }
  }
}
</script>
